export const getJobId = (cache, jobName) => cache.identify({
  __typename: 'Job',
  name: jobName,
});
